const EDITABLE_TAGS = new Set(["INPUT", "TEXTAREA", "SELECT"]);

const TYPING_ROLES = ["textbox", "searchbox", "combobox", "listbox", "option", "spinbutton", "slider", "menu", "menuitem", "menuitemradio", "menuitemcheckbox", "grid", "tree", "treeitem"];

const TYPING_SELECTOR = TYPING_ROLES.map((role) => `[role="${role}"]`).join(", ");

const OVERLAY_SELECTOR = '[role="dialog"], [role="alertdialog"], [aria-modal="true"], .MuiModal-root:not(.MuiModal-hidden), [data-vaul-drawer]';

const OPEN_MODAL_SELECTOR = '[aria-modal="true"], .MuiModal-root:not(.MuiModal-hidden), [data-vaul-drawer]';

const ACTIVATABLE_SELECTOR = 'button, a[href], summary, [role="button"], [role="link"], [role="switch"], [role="checkbox"], [role="radio"], [role="tab"]';

function asElement(value: EventTarget | Element | null | undefined): Element | null {
  if (!value || typeof Element === "undefined") return null;
  return value instanceof Element ? value : null;
}

function eventElements(event: KeyboardEvent): Element[] {
  const target = asElement(event.target);
  const active = typeof document === "undefined" ? null : asElement(document.activeElement);
  return [target, active].filter((element): element is Element => element !== null);
}

export function isEditableElement(element: Element | null): boolean {
  if (!element) return false;
  if (EDITABLE_TAGS.has(element.tagName)) return true;
  if (element instanceof HTMLElement && element.isContentEditable) return true;
  if (element.getAttribute("contenteditable") === "true") return true;
  return element.closest(TYPING_SELECTOR) !== null;
}

export function isInsideOverlay(element: Element | null): boolean {
  if (!element) return false;
  return element.closest(OVERLAY_SELECTOR) !== null;
}

export function hasOpenModal(root: Document | null = typeof document === "undefined" ? null : document): boolean {
  if (!root) return false;
  return root.querySelector(OPEN_MODAL_SELECTOR) !== null;
}

function isActivationKey(event: KeyboardEvent): boolean {
  return event.key === " " || event.key === "Spacebar" || event.code === "Space" || event.key === "Enter";
}

export function keyBelongsToControl(event: KeyboardEvent): boolean {
  if (event.isComposing) return true;
  return eventElements(event).some(
    (element) => isEditableElement(element) || (isActivationKey(event) && element.closest(ACTIVATABLE_SELECTOR) !== null),
  );
}

export function shouldIgnoreGlobalShortcut(event: KeyboardEvent): boolean {
  if (event.defaultPrevented || keyBelongsToControl(event)) return true;
  if (eventElements(event).some(isInsideOverlay)) return true;
  return hasOpenModal();
}
